/** @jsxImportSource @emotion/react */
import { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { accessAPI, downloadFile } from "../../utils";
import ArchivoPreview from "../archivoPreview/ArchivoPreview";
import Boton from "../boton";

// Archivos de una interacción de hallazgo (la respuesta del cliente puede
// traer varios): vista previa en línea y, en el menú de cada uno, descargarlo
// o pasarlo a los archivos de la actividad (disponible para el cliente).
// `rutaBase`: endpoints de hallazgos de la plataforma ("colab/hallazgo",
// "admin/hallazgo").
export default function EvidenciasHallazgo({
  rutaBase,
  hallazgoId,
  evidencias,
  idsEnActividad,
  puedeMover,
  onMovido,
  toast
}) {
  const menuRef = useRef(null);
  const [seleccionada, setSeleccionada] = useState(null);
  const [enProceso, setEnProceso] = useState(null);

  const descargar = (evidencia) => {
    setEnProceso(evidencia.archivoId);
    downloadFile(
      `${rutaBase}/${hallazgoId}/evidencia/${evidencia.archivoId}`,
      evidencia.nombre,
      () => setEnProceso(null),
      () => setEnProceso(null)
    );
  };

  const moverAActividad = (evidencia) => {
    setEnProceso(evidencia.archivoId);
    accessAPI(
      "POST",
      `${rutaBase}/${hallazgoId}/evidencia/${evidencia.archivoId}/actividad`,
      {},
      (archivo) => {
        setEnProceso(null);
        onMovido?.(archivo);
        toast?.current?.show({
          severity: "success",
          summary: "Éxito",
          detail: "El archivo se agregó a los archivos de la actividad",
          life: 3000
        });
      },
      (respuesta) => {
        setEnProceso(null);
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta?.[0]?.msg || "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
      }
    );
  };

  const yaEnActividad = (evidencia) => idsEnActividad?.includes(evidencia.archivoId);
  const itemsMenu = seleccionada
    ? [
        { label: "Descargar", icon: "pi pi-download", command: () => descargar(seleccionada) },
        ...(puedeMover
          ? [
              {
                label: yaEnActividad(seleccionada) ? "Ya está en la actividad" : "Mover a la actividad",
                icon: "pi pi-folder",
                disabled: yaEnActividad(seleccionada),
                command: () => moverAActividad(seleccionada)
              }
            ]
          : [])
      ]
    : [];

  return (
    <div css={{ marginTop: "0.5em" }}>
      <Menu model={itemsMenu} popup ref={menuRef} appendTo={typeof document !== "undefined" ? document.body : undefined} />
      <DataTable
        // DataTable no redibuja las celdas cuando cambia un estado externo: la
        // key fuerza a redibujar el loader de la fila (como en el admin)
        key={`evidencias-${enProceso}`}
        value={evidencias}
        dataKey="archivoId"
        size="small"
      >
        <Column
          header="Archivo"
          body={(evidencia) => <ArchivoPreview nombre={evidencia.nombre} hash={evidencia.hash} />}
        />
        <Column
          body={(evidencia) => (
            <Boton
              texto
              negro
              loader={enProceso === evidencia.archivoId}
              callback={(e) => {
                setSeleccionada(evidencia);
                menuRef.current.toggle(e);
              }}
            >
              <i className="pi pi-ellipsis-v"></i>
            </Boton>
          )}
          style={{ width: "4rem", textAlign: "center" }}
        />
      </DataTable>
    </div>
  );
}
